var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStatusSubmit = function SvgStatusSubmit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 9.56104V20.2277H15.6667",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.453 10.367C16.7495 10.0748 16.749 9.60283 16.4495 9.31037L13.888 6.80857C13.1793 6.09759 12.116 7.16432 12.8247 7.8753L13.6905 8.74083C13.8877 8.93799 13.8208 9.09758 13.5446 9.09758H10.0975C9.683 9.09758 9.34745 9.43618 9.34745 9.85193C9.34745 10.2682 9.68525 10.606 10.0975 10.606H13.5446C13.8223 10.606 13.8877 10.7659 13.6905 10.9628L12.8247 11.8281C12.116 12.5393 13.1793 13.6058 13.888 12.8948L16.453 10.367ZM9.23565 14.7538C11.9268 17.4616 16.2904 17.4616 18.9815 14.7538C21.6728 12.0463 21.6728 7.65633 18.9815 4.94881C16.2904 2.24102 11.9268 2.24102 9.23565 4.94881C8.89309 5.2932 8.89309 5.85216 9.23565 6.19655C9.57821 6.5412 10.1335 6.5412 10.4761 6.19655C12.4823 4.17832 15.735 4.17832 17.7413 6.19655C19.7473 8.21504 19.7473 11.4876 17.7413 13.5061C15.735 15.5243 12.4823 15.5243 10.4761 13.5061C10.1335 13.1614 9.57821 13.1614 9.23565 13.5061C8.89309 13.8504 8.89309 14.4091 9.23565 14.7538Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStatusSubmit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/status-submit.078f2f6a.svg";
export { ForwardRef as ReactComponent };